import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {ICheckBoxValueType} from "../../interfaces/ICheckBoxValueType";
import {IDictItemType} from "@amlCore/interfaces";

/**
 * Компонент для группы чекбоксов, значения выбранные которых должны склеиваться в одну строку
 */

@Component({
  selector: 'app-joined-multi-checkbox',
  template: `
    <div class="d-flex flex-row bd-highlight">
      <div class="ml-3" *ngFor="let item of items">
        <div class="aml-checkbox-form">
          <label class="mr-2">
            <div class="aml-checkbox">
              <input type="checkbox" (click)="onSelectItem(item, $event)" [checked]="item.checked" [disabled]="isReadOnly"/>
              <span class="success"></span>
            </div>
            <span class="aml-checkbox-text" label *ngIf="showCode" class="form-label">{{item.code}} - {{item[nameField]}}</span>
            <span class="aml-checkbox-text" *ngIf="!showCode" class="form-label">{{item[nameField]}}</span>
          </label>
        </div>
      </div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JoinedMultiCheckboxComponent),
      multi: true,
    },
  ],
})
export class JoinedMultiCheckboxComponent implements ControlValueAccessor, OnInit{
  @Input() formControl: FormControl;
  @Input() isReadOnly: boolean;
  @Input() showCode: boolean = false;
  @Input() dictItems: IDictItemType[];
  @Input() separator: string = ';';
  @Input() nameField: string = 'name';
  @Output() codeAdded = new EventEmitter<string>();
  @Output() codeDeleted = new EventEmitter<string>();
  onChange = (result: any) => {};
  onTouch = () => {
  }

  constructor(private readonly modalService: NgbModal) {}
  items: ICheckBoxValueType[];

  ngOnInit(){
    this.items = this.dictItems?.map(obj => ({...obj as ICheckBoxValueType}));
  }

  writeValue(value: string) {
    const values = value.split(this.separator);
    this.items.forEach(item => {
      item.checked = values.includes(item.code);
    })
  }

  registerOnChange(callback) {
    this.onChange = callback;
  }

  registerOnTouched(callback) {
    this.onTouch = callback;
  }

  onSelectItem(item: ICheckBoxValueType, event: any) {
    item.checked = event.target.checked;
    if (event.target.checked){
      this.codeAdded.emit(item.code);
    } else {
      this.codeDeleted.emit(item.code);
    }
    this.onChange(this.items.filter(item => item.checked).map(obj => obj.code).join(this.separator));
  }

}
